<!-- eslint-disable vue/valid-v-bind -->
<template>
    <div
        id="message-send-box-wrapper"
        :style="focus ? {'backgroundColor': 'white'} : {}"
        @drop="dropHandler"
    >
        <div class="send-header-bar">
            <el-popover
                placement="top"
                width="400"
                trigger="click"
            >
                <div class="emojis">
                    <div
                        v-for="item in emojiName"
                        :key="item"
                        class="emoji"
                        @click="chooseEmoji(item)"
                    >
                        <img
                            :src="emojiUrl + emojiMap[item]"
                            style="width:30px;height:30px"
                        >
                    </div>
                </div>
                <i
                    slot="reference"
                    class="iconfont iconsmile1"
                    :title="$t('发表情')"
                />
            </el-popover>
            <i
                class="iconfont iconimage"
                :title="$t('发图片')"
                @click="handleSendImageClick"
            />
            <i
                class="el-icon-camera"
                :title="$t('发视频')"
                @click="handleSendVideoClick"
            />
            <i
                class="el-icon-folder"
                :title="$t('发文件')"
                @click="handleSendFileClick"
            />
            <!-- <el-dropdown>
                <span class="el-dropdown-link">
                    <i
                        v-if="toAccount !== userID"
                        class="el-icon-phone-outline"
                        title="语音通话"
                    />
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="trtcCalling('video')">视频通话</el-dropdown-item>
                    <el-dropdown-item @click.native="trtcCalling('audio')">语音通话</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown> -->
        </div>
        <div class="bottom">
            <textarea
                ref="text-input"
                v-model="messageContent"
                rows="5"
                resize="false"
                class="text-input"
                :placeholder="$t('Please type something...')"
                @focus="focus = true"
                @blur="focus = false"
                @input="inputChange"
                @keydown.enter.exact.prevent="handleEnter"
                @keyup.ctrl.enter.prevent.exact="handleLine"
                @keydown.up.stop="handleUp"
                @keydown.down.stop="handleDown"
            />
            <div
                class="btn-send"
                @click="sendTextMessage"
            >
                <el-button
                    type="primary"
                    size="mini"
                    class="send-btn"
                >{{ $t('发送') }}</el-button>
            </div>
        </div>
        <input
            id="imagePicker"
            ref="imagePicker"
            type="file"
            accept=".jpg, .jpeg, .png, .gif, .bmp"
            style="display:none"
            @change="sendImage"
        >
        <input
            id="filePicker"
            ref="filePicker"
            type="file"
            style="display:none"
            @change="sendFile"
        >
        <input
            id="videoPicker"
            ref="videoPicker"
            type="file"
            style="display:none"
            accept=".mp4"
            @change="sendVideo"
        >
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { emojiMap, emojiName, emojiUrl } from '@/utils/emojiMap'

export default {
    name: 'MessageSendBox',
    components: {},
    props: [ 'scrollMessageListToButtom' ],
    data() {
        return {
            callingList: [],
            groupAtList: [],
            listTpye: '',
            callingType: '', // 音频类型
            groupAt: false,
            colors: [ '#99A9BF', '#F7BA2A', '#FF9900' ],
            messageContent: '',
            isSendCustomMessage: false,
            surveyDialogVisible: false,
            form: {
                data: '',
                description: '',
                extension: ''
            },
            rate: 5, // 评分
            file: '',
            emojiMap,
            emojiName,
            emojiUrl,
            atUserID: '',
            focus: false,
            popoverVisible: false,
            emojiShow: true,
            bigEmojiShow: false,
            bigEmojiList: [
                {
                    icon: 'yz00',
                    list: [ 'yz00', 'yz01', 'yz02', 'yz03', 'yz04', 'yz05', 'yz06', 'yz07', 'yz08', 'yz09', 'yz10', 'yz11', 'yz12', 'yz13', 'yz14', 'yz15', 'yz16', 'yz17' ]
                },
                {
                    icon: 'ys00',
                    list: [ 'ys00', 'ys01', 'ys02', 'ys03', 'ys04', 'ys05', 'ys06', 'ys07', 'ys08', 'ys09', 'ys10', 'ys11', 'ys12', 'ys13', 'ys14', 'ys15' ]
                },
                {
                    icon: 'gcs00',
                    list: [ 'gcs00', 'gcs01', 'gcs02', 'gcs03', 'gcs04', 'gcs05', 'gcs06', 'gcs07', 'gcs08', 'gcs09', 'gcs10', 'gcs11', 'gcs12', 'gcs13', 'gcs14', 'gcs15', 'gcs16' ]
                }
            ],
            curItemIndex: 0,
            curBigEmojiItemList: []
        }
    },
    computed: {
        ...mapGetters([ 'toAccount', 'currentConversationType', 'appId', 'exhibitionId', 
        'subjectType' ]),
        ...mapState({
            userID: state => state.timStore.currentUserProfile.userID
        })
    },
    mounted() {
        this.$refs['text-input'].addEventListener('paste', this.handlePaste)
        this.$bus.$on('reEditMessage', this.reEditMessage)
    },
    beforeDestroy() {
        this.$refs['text-input'].removeEventListener('paste', this.handlePaste)
    },
    methods: {
        trtcCalling(type) {
            this.listTpye = 'calling'
            if (type === 'video') {
                this.callingType = 'video'
            }
            if (type === 'audio') {
                this.callingType = 'audio'
            }
            // 呼叫方设置
            if (this.currentConversationType === 'C2C') {
                const member = [ this.toAccount ]
                const callingData = {
                    memberList: member,
                    type: 'C2C'
                }
                this.$store.commit('setCallingList', callingData)
                this.$bus.$emit(`${type}-call`)
            }
            // this.$store.commit('pushCurrentMessageList', true)
        },
        handleEmojiShow() {
            this.emojiShow = true
            this.bigEmojiShow = false
        },
        handleBigEmojiShow(index) {
            const elm = document.getElementById('bigEmojiBox')
            elm && (elm.scrollTop = 0)
            this.curItemIndex = index
            this.curBigEmojiItemList = this.bigEmojiList[index].list
            this.emojiShow = false
            this.bigEmojiShow = true
        },
        chooseBigEmoji(item) {
            this.popoverVisible = false
            const message = this.$TIM.createFaceMessage({
                to: this.toAccount,
                conversationType: this.currentConversationType,
                payload: {
                    index: this.curItemIndex + 1,
                    data: `${item}@2x`
                },
                cloudCustomData: JSON.stringify({
                    appId: this.appid,
                    exhibitionId: this.exhibitionId,
                    subjectType: this.subjectType,
                    userAccountId: this.userID
                })
            })
            this.$store.commit('pushCurrentMessageList', message)
            this.$bus.$emit('scroll-bottom')
            this.$TIM.sendMessage(message).catch((error) => {
                this.$message.error(error.message)
            })
        },
        reEditMessage(payload) {
            this.messageContent = payload
        },
        handleUp() {},
        handleDown() {},
        handleEnter() {
            this.sendTextMessage()
        },
        inputChange(value) {
            if (this.currentConversationType === this.$TIM_TYPES.CONV_GROUP && value.data === '@') {
                this.groupAt = true
                this.listTpye = 'groupAt'
            }
            if (value.data === ' ' && this.messageContent.includes('@ ')) {
                this.groupAt = false
                this.listTpye = ''
            }
        },
        handleLine() {
            this.messageContent += '\n'
        },
        handlePaste(e) {
            const clipboardData = e.clipboardData
            let file
            if (clipboardData && clipboardData.files && clipboardData.files.length > 0) {
                file = clipboardData.files[0]
            }

            if (typeof file === 'undefined') {
                return
            }
            // 1. 创建消息实例，接口返回的实例可以上屏
            const message = this.$TIM.createImageMessage({
                to: this.toAccount,
                conversationType: this.currentConversationType,
                payload: {
                    file
                },
                cloudCustomData: JSON.stringify({
                    appId: this.appid,
                    exhibitionId: this.exhibitionId,
                    subjectType: this.subjectType,
                    userAccountId: this.userID
                }),
                onProgress: (percent) => {
                    this.$set(message, 'progress', percent) // 手动给message 实例加个响应式属性: progress
                }
            })
            this.$store.commit('pushCurrentMessageList', message)

            // 2. 发送消息
            const promise = this.$TIM.sendMessage(message)
            promise.catch((error) => {
                this.$store.commit('showMessage', {
                    type: 'error',
                    message: error.message
                })
            })
        },
        dropHandler(e) {
            e.preventDefault()
            const file = e.dataTransfer.files[0]
            let message = {}
            if (file.type === 'video/mp4') {
                message = this.$TIM.createVideoMessage({
                    to: this.toAccount,
                    conversationType: this.currentConversationType,
                    payload: {
                        file
                    },
                    cloudCustomData: JSON.stringify({
                        appId: this.appid,
                        exhibitionId: this.exhibitionId,
                        subjectType: this.subjectType,
                        userAccountId: this.userID
                    }),
                    onProgress: (percent) => {
                        this.$set(message, 'progress', percent) // 手动给message 实例加个响应式属性: progress
                    }
                })
            } else {
                message = this.$TIM.createFileMessage({
                    to: this.toAccount,
                    conversationType: this.currentConversationType,
                    payload: {
                        file
                    },
                    cloudCustomData: JSON.stringify({
                        appId: this.appid,
                        exhibitionId: this.exhibitionId,
                        subjectType: this.subjectType,
                        userAccountId: this.userID
                    }),
                    onProgress: (percent) => {
                        this.$set(message, 'progress', percent) // 手动给message 实例加个响应式属性: progress
                    }
                })
            }
            this.$store.commit('pushCurrentMessageList', message)
            this.$TIM
                .sendMessage(message)
                .then(() => {
                    this.$refs.videoPicker.value = null
                })
                .catch((imError) => {
                    this.$store.commit('showMessage', {
                        message: imError.message,
                        type: 'error'
                    })
                })
        },
        async sendTextMessage() {
            if (!this.$store.getters.isSDKReady || !this.$store.getters.timIsLogin) {
              await this.$store.dispatch('getOnlineCustomer', this.$store.getters.isLogin)
            }
            if (this.messageContent === '' || this.messageContent.trim().length === 0) {
                this.messageContent = ''
                this.$message.warning(this.$t('不能发送空消息哦！'))
                return
            }
            console.log(this.toAccount)
            const message = this.$TIM.createTextMessage({
                to: this.toAccount,
                conversationType: this.currentConversationType,
                payload: { text: this.messageContent },
                cloudCustomData: JSON.stringify({
                    appId: this.appid,
                    exhibitionId: this.exhibitionId,
                    subjectType: this.subjectType,
                    userAccountId: this.userID
                }),
            })
            this.$store.commit('pushCurrentMessageList', message)
            this.$bus.$emit('scroll-bottom')
            this.$TIM.sendMessage(message).catch((error) => {
                this.$message.error(error.message)
            })
            this.messageContent = ''
        },
        random(min, max) {
            return Math.floor(Math.random() * (max - min + 1) + min)
        },
        chooseEmoji(item) {
            this.messageContent += item
        },
        handleSendImageClick() {
            this.$refs.imagePicker.click()
        },
        handleSendFileClick() {
            this.$refs.filePicker.click()
        },
        handleSendVideoClick() {
            this.$refs.videoPicker.click()
        },
        async sendImage() {
            if (!this.$store.getters.isSDKReady || !this.$store.getters.timIsLogin) {
              await this.$store.dispatch('getOnlineCustomer', this.$store.getters.isLogin)
            }
            const message = this.$TIM.createImageMessage({
                to: this.toAccount,
                conversationType: this.currentConversationType,
                payload: {
                    file: document.getElementById('imagePicker') // 或者用event.target
                },
                cloudCustomData: JSON.stringify({
                    appId: this.appid,
                    exhibitionId: this.exhibitionId,
                    subjectType: this.subjectType,
                    userAccountId: this.userID
                }),
                onProgress: (percent) => {
                    this.$set(message, 'progress', percent) // 手动给message 实例加个响应式属性: progress
                }
            })
            this.$store.commit('pushCurrentMessageList', message)
            this.$TIM
                .sendMessage(message)
                .then(() => {
                    this.$refs.imagePicker.value = null
                })
                .catch((imError) => {
                    this.$store.commit('showMessage', {
                        message: imError.message,
                        type: 'error'
                    })
                })
        },
        async sendFile() {
            if (!this.$store.getters.isSDKReady || !this.$store.getters.timIsLogin) {
              await this.$store.dispatch('getOnlineCustomer', this.$store.getters.isLogin)
            }
            const message = this.$TIM.createFileMessage({
                to: this.toAccount,
                conversationType: this.currentConversationType,
                payload: {
                    file: document.getElementById('filePicker') // 或者用event.target
                },
                cloudCustomData: JSON.stringify({
                    appId: this.appid,
                    exhibitionId: this.exhibitionId,
                    subjectType: this.subjectType,
                    userAccountId: this.userID
                }),
                onProgress: (percent) => {
                    this.$set(message, 'progress', percent) // 手动给message 实例加个响应式属性: progress
                }
            })
            this.$store.commit('pushCurrentMessageList', message)
            this.$TIM
                .sendMessage(message)
                .then(() => {
                    this.$refs.filePicker.value = null
                })
                .catch((imError) => {
                    this.$store.commit('showMessage', {
                        message: imError.message,
                        type: 'error'
                    })
                })
        },
        async sendVideo() {
            if (!this.$store.getters.isSDKReady || !this.$store.getters.timIsLogin) {
              await this.$store.dispatch('getOnlineCustomer', this.$store.getters.isLogin)
            }
            const message = this.$TIM.createVideoMessage({
                to: this.toAccount,
                conversationType: this.currentConversationType,
                payload: {
                    file: document.getElementById('videoPicker') // 或者用event.target
                },
                cloudCustomData: JSON.stringify({
                    appId: this.appid,
                    exhibitionId: this.exhibitionId,
                    subjectType: this.subjectType,
                    userAccountId: this.userID
                }),
                onProgress: (percent) => {
                    this.$set(message, 'progress', percent) // 手动给message 实例加个响应式属性: progress
                }
            })
            this.$store.commit('pushCurrentMessageList', message)
            this.$TIM
                .sendMessage(message)
                .then(() => {
                    this.$refs.videoPicker.value = null
                })
                .catch((imError) => {
                    this.$message.error(imError.message)
                })
        }
    }
}
</script>
<style lang="scss" scoped>
#message-send-box-wrapper {
  box-sizing: border-box;
  overflow: hidden;
  padding: 3px 20px 35px 20px;
}

.emojis {
  height: 160px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow-y: scroll;
}

.emoji {
  height: 40px;
  width: 40px;
  box-sizing: border-box;
}

.send-header-bar {
  box-sizing: border-box;
  padding: 3px 0 0 0;
}

.send-header-bar i {
  cursor: pointer;
  font-size: 24px;
  color: gray;
  margin: 0 12px 0 0;
}

.send-header-bar i:hover {
  color:#000000;
}

textarea {
  resize: none;
}

.text-input {
  font-size: 16px;
  width: 100%;
  box-sizing: box-sizing;
  border: none;
  outline: none;
  background-color: transparent;
}

.block {
  padding: 10px 0;
  display: flex;
  align-items: center;
}

.bottom {
  padding-top: 10px;
  position: relative;

  .btn-send {
    cursor: pointer;
    position: absolute;
    color: #2d8cf0;
    font-size: 30px;
    right: -16px;
    bottom: -35px;
    padding: 6px 6px 4px 4px;
    border-radius: 50%;
    .tim-send-btn {
        width: 100px;
        height: 40px;
        background: red;
    }
  }
}
.el-popover {
  padding: 12px 0 0 0 !important;
}
</style>
